import request from "@/utils/request";

// 查询可发起的所有流程
export function queryProcessTable(params) {
  return request({
    url: "/process/processStart/page",
    method: "get",
    params,
  });
}
// 发起流程
export function startProcess(data) {
  return request({
    url: "/process/processStart/startProcess",
    method: "post",
    data,
  });
}

// 流程发起页面，流程定义信息
export function getStartProcessInfo(definitionId) {
  return request({
    url: `/process/processStart/getStartProcessInfo/${definitionId}`,
    method: "get",
  });
}
